$(document).ready(function(){
  $('.carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    dots: true
  });
});
$(document).ready(function(){
  $('.silk-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 500,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  }).show(); // show after initializing
});

$(document).ready(function(){
  $('.google-reviews-grid').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 500,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  }).show(); // show after initializing
});







 $(document).ready(function () {
    const redirects = {
      "/collections/waist-trainers-for-women-1": "/collections/waist-trainers-for-women",
      "/collections/waist-trainers-for-women-4": "/collections/waist-trainers-for-women",
      "/collections/waist-trainers": "/collections/waist-trainers-for-women",
      "/collections/plus-size-corsets-1": "/collections/plus-size-corsets",
      // Add more as needed
    };

    const currentPath = window.location.pathname;

    if (redirects[currentPath]) {
      window.location.href = redirects[currentPath];
    }
  });
